import { render } from "./PropertySupervise.vue?vue&type=template&id=71bee704&scoped=true"
import script from "./PropertySupervise.vue?vue&type=script&lang=js"
export * from "./PropertySupervise.vue?vue&type=script&lang=js"

import "./PropertySupervise.vue?vue&type=style&index=0&id=71bee704&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bee704"]])

export default __exports__